var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01204 9.00021C7.27724 9.00027 7.53155 9.10567 7.71905 9.29321L12.012 13.5862L16.305 9.29321C16.4936 9.11106 16.7462 9.01026 17.0084 9.01254C17.2706 9.01482 17.5215 9.11999 17.7069 9.3054C17.8923 9.4908 17.9974 9.74162 17.9997 10.0038C18.002 10.266 17.9012 10.5186 17.719 10.7072L12.719 15.7072C12.5315 15.8947 12.2772 16 12.012 16C11.7469 16 11.4926 15.8947 11.305 15.7072L6.30504 10.7072C6.16523 10.5674 6.07003 10.3892 6.03146 10.1952C5.99289 10.0013 6.0127 9.80026 6.08837 9.61756C6.16404 9.43486 6.29218 9.2787 6.45659 9.16881C6.621 9.05893 6.81429 9.00026 7.01204 9.00021Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow-down-icon.9ae8c14a38caa32db6ff2103b2f435d9.svg";
export { ForwardRef as ReactComponent };